module.exports = __webpack_public_path__ + "static/media/step2.0746c1dc.png";